import React from 'react';

export const ErrorPage = () => {
    return <div>404/page Not found</div>
}